<div class="matrix" role="table" [style.--status-matrix-columns]="columnCount()">
  <div class="row header" role="row">
    <div class="label" role="columnheader">{{ labelHeader() }}</div>
    @for (header of headers(); track $index) {
      <div class="cell" role="columnheader">{{ header }}</div>
    }
  </div>

  <div class="body" role="rowgroup">
    @for (row of rows(); track row.id) {
      <div class="row item" role="row">
        <div
          class="label"
          role="rowheader"
          [matTooltip]="row.labelTooltip ?? ''"
          [matTooltipDisabled]="!row.labelTooltip"
          matTooltipClass="dmb-status-matrix-tooltip">
          <div class="label-text">{{ row.label }}</div>
          @if (row.subLabel) {
            <div class="sub-label">{{ row.subLabel }}</div>
          }
        </div>
        @for (cell of row.cells; track $index) {
          <div class="cell" role="cell">
            @if (cellsClickable()) {
              <button
                type="button"
                class="cell-button"
                [attr.aria-label]="cell.tooltip ?? row.label"
                [matTooltip]="cell.tooltip ?? ''"
                [matTooltipDisabled]="!cell.tooltip"
                [matTooltipPosition]="tooltipPosition()"
                matTooltipClass="dmb-status-matrix-tooltip"
                (click)="onCellClick(row, cell, $index)">
                <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ cell, row, index: $index }" />
              </button>
            } @else {
              <div
                class="cell-content"
                [matTooltip]="cell.tooltip ?? ''"
                [matTooltipDisabled]="!cell.tooltip"
                [matTooltipPosition]="tooltipPosition()"
                matTooltipClass="dmb-status-matrix-tooltip">
                <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ cell, row, index: $index }" />
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  @if (showFooter()) {
    <div class="row footer" role="row">
      <div class="footer-text" role="cell">{{ rowCount() }}</div>
    </div>
  }
</div>

<ng-template #content let-cell="cell" let-row="row" let-index="index">
  @if (cellTemplate(); as custom) {
    <ng-container [ngTemplateOutlet]="custom.template" [ngTemplateOutletContext]="{ $implicit: cell, row, index }" />
  } @else {
    <dmb-progress-bar [value]="cell.value" [relativeValue]="cell.relativeValue" />
  }
</ng-template>
